module.exports = __webpack_public_path__ + "static/media/ic_database.42b6abf6.svg";